<template>
  <div class="goal-template-row d-flex flex-column">
    <div class="position-relative flex-grow-1">
      <div class="title-row d-flex">
        <i class="goal-icon flex-shrink-0 mr-2"></i>
        <div class="text-large bold">{{ goal.title }}</div>
      </div>
      <div class="description mt-2 text-medium-1 text-secondary" v-if="goal.description">
        {{ goal.description }}
      </div>
      <div class="krs mt-4" v-if="keyResults && keyResults.length > 0">
        <div class="kr d-flex" v-for="kr in keyResults" :key="kr.id">
          <i class="kr-icon flex-shrink-0 mr-2"></i>
          <div class="text-normal-1 mr-2">{{ kr.title }}</div>
        </div>
      </div>
      <div class="tags d-flex justify-content-end">
        <div
          class="badge-default flex-center text-secondary mr-2"
          v-for="team in goalTeams"
          :key="team"
        >
          {{ team }}
        </div>
        <b-button
          class="use-goal text-small-1 py-1 text-nowrap d-flex align-items-center align-self-baseline"
          variant="primary"
          pill
          @click="$emit('select', goal)"
        >
          <i class="copy-white-icon mr-1"></i>
          <i class="copy-icon mr-1"></i>
          Copy Goal
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as R from 'ramda'
import { BButton } from 'bootstrap-vue'

/**
 * This is the row for Template goal
 * This shows goal title and all the KRs
 */
export default {
  name: 'GoalTemplateRow',
  props: ['goal', 'allTeams'],
  components: {
    BButton
  },
  data() {
    return {}
  },
  computed: {
    goalTeams() {
      if (!this.goal.metadataList) return []
      const teamIdList = this.goal.metadataList.map(metadata => metadata.functionId)
      return R.uniq(teamIdList).map(teamId => this.allTeams.find(t => t.id === teamId)?.title)
    },
    keyResults() {
      return this.goal.keyResults?.filter(kr => !R.isEmpty(kr))
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
@import '~@/styles/components/_badge.scss';

$gutterSpace: 56px;
$actionBtnHeight: 30px;

$bottomSpacing: 30px + $actionBtnHeight;
.goal-template-row {
  padding: 30px $gutterSpace $bottomSpacing $gutterSpace;
  border-radius: 10px;
  box-shadow: $cardShadow;
}

.description,
.krs {
  padding-left: 28px;
}

.goal-icon {
  @include dimension(19px, 19px);
  background-size: contain;
  margin-top: 6px;
}

.use-goal {
  margin-top: 1px;
  transition: opacity ease-in 200ms;
  transition-delay: 100ms;

  &:not(:hover) {
    @extend .badge-default;
    border: 1px solid transparent;
    padding: 4px 12px;
  }

  &:hover {
    .copy-white-icon {
      display: initial;
    }

    .copy-icon {
      display: none;
    }
  }
}

.copy-white-icon {
  display: none;
}

.kr-icon {
  @include dimension(10px, 13px);
  margin-top: 6px;
}

.kr {
  padding: 6px 0;
}

.tags {
  position: absolute;
  bottom: -30px;
  right: 0;
}

@include media-breakpoint-down(md) {
  $bottomSpacingSmall: 16px + $actionBtnHeight;
  .goal-template-row {
    padding: 16px 16px $bottomSpacingSmall 16px;
  }
}
</style>
